import React, { memo, useContext, useEffect, useReducer } from 'react';
import { StyleSheet, css } from 'aphrodite';
import './css/HomePage1Section14.css';
import { useSnackbar } from 'notistack';
import { context } from '../../../../globalState/GlobalState';
import SmallGamesWidget1 from '../../../uiElements/gamesWidgets/smallGamesWidget1/SmallGamesWidget1';
import { isValidString } from '../../../../catalog/Validity';
import { fetchLimitedUpcomingEventsAPI } from '../../../apiCalls/EventAPICalls';
import HomePage1ArticlesEvents1 from '../uiElements/homePage1Articles/homePage1ArticlesEvents1/HomePage1ArticlesEvents1';
import BannerComponent from '../../../uiElements/storeComponents/bannerComponent/BannerComponent';
import { checkProductsValidity, checkTicketsValidity } from '../../../../catalog/Store';

const initialState = {
    events: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchUpcomingEvents':
            return { ...state, events: action.events };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const HomePage1Section14 = () => {
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetch() {
            setState({ type: 'setLoadingSpinner', loadingSpinner: true });
            await fetchLimitedUpcomingEventsAPI(globalState.accountId, 1, setState, enqueueSnackbar);
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
        }
        fetch();
    }, []);

    const styles = StyleSheet.create({
        container: {
            // backgroundColor: isValidString(globalState.websiteStyles.colors.secondaryColor) ? globalState.websiteStyles.colors.secondaryColor : '#181e29',
            backgroundImage: `linear-gradient(to bottom, ${globalState.websiteStyles.colors.primaryColor} -60%, ${isValidString(globalState.websiteStyles.colors.secondaryColor) ? globalState.websiteStyles.colors.secondaryColor : '#181e29'} 60%)`,
        },
    });

    return (
        <div className={`homepage1-section14-container-container p-t-50px x-center ${css(styles.container)}`}>
            <div className="homepage1-section14-container x-center">
                <div className="homepage1-section14-games">
                    <SmallGamesWidget1 scheduled={false} whiteTitle />
                    <SmallGamesWidget1 scheduled whiteTitle />
                </div>
                <div className="homepage1-section14-articles">
                    <HomePage1ArticlesEvents1 whiteTitle />
                </div>
            </div>
            <div className="homepage1-section14-events x-center" style={{ display: state.events.length === 0 ? 'none' : '' }}>
                <BannerComponent text="Check out our Events" buttonText="View Events" navLink="/events/upcoming" flipped={false} fullWidth={false} />
            </div>
            <div className="homepage1-section14-store-tickets">
                {checkProductsValidity(globalState) ? (
                    <div className="homepage1-section14-store x-center">
                        <BannerComponent text="Check out our Store" buttonText="View Store" navLink="/store" flipped fullWidth={false} store />
                    </div>
                ) : null}
                {checkTicketsValidity(globalState) ? (
                    <div className="homepage1-section14-tickets x-center">
                        <BannerComponent text="Check out our Tickets" buttonText="View Tickets" navLink="/tickets" flipped={false} fullWidth={false} tickets />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default memo(HomePage1Section14);
